$(document).ready(($) => {
    const initializeCarousel = (carouselID, prevBtnID, nextBtnID, options) => {
        const owl = $(`${carouselID}`);
        const prevBtn = $(`${prevBtnID}`);
        const nextBtn = $(`${nextBtnID}`);
        owl.owlCarousel(options);
        prevBtn.click(() => {
            owl.trigger("prev.owl.carousel");
        });
        nextBtn.click(() => {
            owl.trigger("next.owl.carousel");
        });
        owl.on("changed.owl.carousel", (event) => {
            if (event.item.index === 0) {
                prevBtn.addClass("disabled");
            } else {
                prevBtn.removeClass("disabled");
            }
            if (event.item.index === event.item.count - 1) {
                nextBtn.addClass("disabled");
            } else {
                nextBtn.removeClass("disabled");
            }
        });
    };
    const commonCarousel = {
        // autoWidth: false,
        // items: 3,
        margin: 20,
        center: true,
        // autoWidth: false,
        items: 3,
        // autoplay: true,
        // autoplayTimeout: 3000,
        // autoplaySpeed: true,
        smartSpeed: 2500,
        dots: false,
        responsive: {
            1340: {
                center: true
            },
            0: {
                center: false
            }
        }
    };
    initializeCarousel("#reviews-carousel", "#reviews-carousel-left", "#reviews-carousel-right", {
        ...commonCarousel,
        margin: 20,
        responsive: {
            1440: {
                center: true,
                items: 3,
              
            },
            1024: {
                center: true,
                items: 3,
            },
            575: {
                center: false,
                items: 2,
            },
            0: {
                center: false,
                autoWidth: false, items: 1
            }
        }
    });
    initializeCarousel("#service-carousel", "#service-carousel-left", "#service-carousel-right", {
        ...commonCarousel,
        margin: 20,
        responsive: {
            1440: {
                center: true
            },
            1024: {
                center: true,
            },
            740: {
                center: false,
                items: 2,
            },
            0: {
                autoWidth: false, items: 1
            }
        }
    });
    initializeCarousel("#portfolio-carousel", "#portfolio-carousel-left", "#portfolio-carousel-right", {
        ...commonCarousel,
        responsive: {
            740: {
                center: false,
                margin: 20,
                items: 3,
                autoWidth: false,
            },
            560: {
              
                center: false,
                margin: 20,
                items: 2,
                autoWidth: false,
            },
            300: {
                center: false,
                margin: 20,
                autoWidth: false,
                items: 2,
            },
            0: {
                autoWidth: false,
                center: false,
            }
        }
    });
    initializeCarousel("#shop-carousel", "#shop-carousel-left", "#shop-carousel-right", {
        ...commonCarousel,
        responsive: {
            740: {
                center: false,
                margin: 20,
                items: 3,
                autoWidth: true,
            },
            560: {
                center: false,
                margin: 20,
                items: 3,
                autoWidth: true,
            },
            300: {
                center: false,
                margin: 8,
                autoWidth: false,
                items: 1,
            },
            0: {
                autoWidth: false,
                center: false,
            }
        }
    });
});
